import React from 'react'
import moment from 'moment'
import { Spacer, Stack, Text, Link, Flex } from '@chakra-ui/react'
import ToggleColorMode from '_components/ToggleColorMode'

function Footer({ mode = 'normal' }) {
  const plansPricing = mode !== 'normal' ? 'https://www.ranktracker.com/pricing/' : '/plans'

  return (
    <Stack
      direction={{
        base: 'column',
        xl: 'row'
      }}
      align="center"
      justify="space-between"
      pt="4"
      pb="4"
      w="full"
      spacing="3"
    >
      <Stack
        wrap="wrap"
        direction={{
          base: 'column',
          sm: 'row'
        }}
        align={{
          base: 'center',
          sm: 'start'
        }}
        color="brand.muted"
        spacing={{
          base: 2,
          sm: 3
        }}
      >
        <Link href="https://www.ranktracker.com/how-it-works" target="_blank">
          About
        </Link>
        <Link href={plansPricing}>Plan and pricing</Link>
        <Link href="/addons">Addons</Link>
        <Link href="https://www.ranktracker.com/affiliate-program/" target="_blank">
          Earn Money
        </Link>
        <Link href="https://help.ranktracker.com/en/" target="_blank">
          Help
        </Link>
        <Link href="https://www.ranktracker.com/privacy-policy/" target="_blank">
          Privacy policy
        </Link>
        <Link href="https://www.ranktracker.com/terms-and-conditions/" target="_blank">
          Terms and conditions
        </Link>
      </Stack>
      <Spacer />
      <Text color="brand.muted" textAlign="center">
        &copy; 2016 - {moment(new Date()).format('YYYY')} Ranktracker. All Rights Reserved.
      </Text>
      {mode !== 'normal' && <Flex justify="end" w={{base: '100%', xl: 'auto'}}><ToggleColorMode /></Flex>}
    </Stack>
  )
}

export default Footer
